// 본문 제목(h1~h3) 우측 hover 시 노출되는 anchor 링크 복사 버튼
// <h2 id="abc" data-controller="components--anchor-copy" data-components--anchor-copy-id-value="abc">
//   제목
//   <button data-action="components--anchor-copy#copy">...</button>
// </h2>
import { Controller } from "@hotwired/stimulus";
import { createFlash } from "@/utils/flash";
import { t } from "@/utils/i18n";

export default class extends Controller {
  static values = { id: String };

  copy(event) {
    event.preventDefault();
    event.stopPropagation();

    const url = `${window.location.origin}${window.location.pathname}#${this.idValue}`;

    this.writeToClipboard(url)
      .then(() => {
        createFlash({
          key: "check",
          ttl: 2,
          message: t("clipboard.section_link_copied", "섹션 링크가 복사되었습니다."),
          stack: false,
        });
      })
      .catch(() => {
        createFlash({
          key: "error",
          ttl: 2,
          message: t("clipboard.section_link_failed", "링크 복사에 실패했습니다."),
          stack: false,
        });
      });
  }

  writeToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }

    // 비보안 컨텍스트 폴백
    return new Promise((resolve, reject) => {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try {
        document.execCommand("copy") ? resolve() : reject();
      } catch (error) {
        reject(error);
      } finally {
        document.body.removeChild(textarea);
      }
    });
  }
}
